import React, { useEffect, useState } from 'react';
import { NAV_LINKS, PERSONAL_INFO } from '../constants/data';

const Header = ({ mobileMenuOpen, toggleMobileMenu, closeMobileMenu }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="header__inner">
        <a href="#home" className="header__logo" onClick={closeMobileMenu}>
          {PERSONAL_INFO.initials.toLowerCase()}<span className="header__logo-dot">.</span>dev
        </a>

        <nav className="header__nav">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="header__nav-link">
              {link.label}
            </a>
          ))}
          <a href="#contact" className="btn btn--sm btn--solid header__cta">
            Hire me
          </a>
        </nav>

        <button
          className={`header__burger ${mobileMenuOpen ? 'is-open' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`mobile-menu ${mobileMenuOpen ? 'is-open' : ''}`}>
        <nav className="mobile-menu__nav">
          {NAV_LINKS.map((link, i) => (
            <a
              key={link.href}
              href={link.href}
              className="mobile-menu__link"
              style={{ transitionDelay: `${0.05 * i + 0.1}s` }}
              onClick={closeMobileMenu}
            >
              <span className="mobile-menu__index">0{i + 1}</span>
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className="btn btn--solid mobile-menu__cta"
            style={{ transitionDelay: `${0.05 * NAV_LINKS.length + 0.1}s` }}
            onClick={closeMobileMenu}
          >
            Hire me
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
